import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { PartnerSettings, TenantList, UsersList } from "@/pages";
import React from "react";
import {
  permissionsUsersReadonly,
  permissionsTenantsReadonly,
  permissionsSettings,
} from "@/utils";
import { userRoutes } from "./userRoutes";
import { locationRoutes } from "./locationRoutes";
import { tenantRoutes } from "./tenantRoutes";
import { companyRoutes } from "./companyRoutes";

const parentPath = "partner-admin";

export const partnerAdminRoutes: React.ReactElement[] = [
  <Route
    key="partner-settings"
    path="settings"
    element={
      <ProtectedRoute
        element={<PartnerSettings />}
        codes={permissionsSettings}
      />
    }
  />,
  <Route
    key="partner-users"
    path="partner-users"
    element={
      <ProtectedRoute
        element={
          <UsersList userFilter="partner" parentPath={parentPath} showUnlink />
        }
        codes={permissionsUsersReadonly}
      />
    }
  />,
  // <Route
  //   key="partner-users-profile"
  //   path="partner-users/:userId/profile"
  //   element={
  //     <ProtectedRoute
  //       element={<UserProfile />}
  //       codes={permissionsUsersReadonly}
  //     />
  //   }
  // />,
  <Route
    key="partners-tenants"
    path="tenants"
    element={
      <ProtectedRoute
        element={<TenantList userFilter="partner" parentPath={parentPath} />}
        codes={permissionsTenantsReadonly}
      />
    }
  />,
  // <Route
  //   key="partners-tenants-companies"
  //   path="tenants/:tenantId/companies"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         <CompanyList
  //           companyFilter="tenant"
  //           parentPath={parentPath}
  //           parentChildfilter="all"
  //         />
  //       }
  //       codes={permissionsCompaniesReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="companies-child-companies"
  //   path="companies/:customerId/child-companies"
  //   element={
  //     <ProtectedRoute
  //       element={<SubsidiaryList parentPath={parentPath} />}
  //       codes={permissionsCompaniesReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="tenants-companies-child-companies"
  //   path="tenants/:tenantId/companies/:customerId/child-companies"
  //   element={
  //     <ProtectedRoute
  //       element={<SubsidiaryList parentPath={parentPath} />}
  //       codes={permissionsCompaniesReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents"
  //   path="documents"
  //   element={
  //     <ProtectedRoute
  //       element={<Documents parentPath={parentPath} />}
  //       codes={permissionsDocumentsReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-add"
  //   path="documents/add"
  //   element={
  //     <ProtectedRoute
  //       element={<AddDocument parentPath={parentPath} />}
  //       codes={permissionsDocumentsFull}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-view"
  //   path="documents/view/:id"
  //   element={
  //     <ProtectedRoute
  //       element={<DocumentView />}
  //       codes={permissionsDocumentsReadonly}
  //     />
  //   }
  // />,
  // <Route
  //   key="documents-edit"
  //   path="documents/edit/:id"
  //   element={
  //     <ProtectedRoute
  //       element={<AddDocument parentPath={parentPath} />}
  //       codes={permissionsDocumentsFull}
  //     />
  //   }
  // />,

  // <Route
  //   key="partner-locations"
  //   path={`locations`}
  //   element={
  //     <ProtectedRoute
  //       element={<CompanyLocations />}
  //       codes={permissionsLocationsReadonly}
  //     />
  //   }
  // />,

  // <Route
  //   key="partner-locations-meters"
  //   path={`locations/meters/:energyType`}
  //   element={
  //     <ProtectedRoute
  //       element={<MeterList />}
  //       codes={permissionsLocationsReadonly}
  //     />
  //   }
  // />,

  // <Route
  //   key="partner-locations-meters-data"
  //   path={`locations/meters/:energyType/:meterNo/data`}
  //   element={
  //     <ProtectedRoute
  //       element={<MeterData />}
  //       codes={permissionsLocationsReadonly}
  //     />
  //   }
  // />,
  <Route path="partner-users/:userId">{userRoutes(parentPath)}</Route>,
  <Route path="companies/:customerId">{companyRoutes(parentPath)}</Route>,
  <Route path="tenants/:tenantId">
    {tenantRoutes(parentPath, { showLocations: true, showCompanies: true })}
  </Route>,
  <Route path="locations">{locationRoutes(parentPath)}</Route>,
];
